import { DeltaOperation } from "quill";
import { IEntityAutoCollectExclusionMap, IEntityMap, ISelfBillBulkSubscription, Permission, UUID, } from ".";

export interface IOrganization {
  name: string;
  orgPhone?: string | null;
  orgEmail?: string | null;
  groups?: IGroupMap; // sub-collection
  entities?: IEntityMap; // sub-collection
  roles?: { [roleId: string]: IRole }; // sub-collection
  logoUrl?: string;
  stripeCustomerId?: string | null;
  selfBilled?: boolean | null;
  autoCollectOrgDefaultEnabled?: boolean | null;
  enterpriseFeaturesEnabled?: boolean | null;
  customEmailContent?: ICustomEmailContent | null;
  bulkPricingCheckoutType?: ISelfBillBulkSubscription | null;
  disableAutoCollect?: boolean | null;
  autoCollectEntityExclusions?: IEntityAutoCollectExclusionMap; // sub-collection
  autoCollectGroupExclusions?: IGroupAutoCollectExclusionMap; // sub-collection
}

export interface ICustomEmailContent {
  customOwnerCollectionEmailContent: string;
  customCoverLetterContent: ICustomCoverLetterContent;
}
export interface ICustomCoverLetterContent {
  Handoff: DeltaOperation[];
  SelfBill: DeltaOperation[];
  Direct?: DeltaOperation[];
}

export interface IGroupMap {
  [groupId: UUID]: IGroup;
}

export interface IGroup {
  id: UUID,
  entities: IPublicEntity[];
  userIds: UUID[];
  name: string;
  default: boolean;
  active: boolean;
}

export type INewGroup = Omit<IGroup, "id">;

export interface IGroupTableData {
  groupName: string;
  entityCount: number;
  id: string;
}

export interface IGroupAutoCollectExclusionMap {
  [groupId: UUID]: {
    id: string;
  };
}

/**
 * @description The public entity is visible to all users in the organization.
 */
export interface IPublicEntity {
  id: UUID;
  name: string;
}

export interface IRole {
  name: string;
  permissions: Permission[];
}
